export default __webpack_public_path__ + "static/media/lipstick-soft-summer.c4f0d89e.png";